const BlogFilterTypeEnum = Object.freeze({
    TAG: "tag",
    AUTHOR: "author",
  });
  
  export default BlogFilterTypeEnum;